import styled from "styled-components";

export const StyledOfferingAutomationsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const StyledAutomationsBreadcrumb = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 1.4rem;
  color: #595959;

  .automations-breadcrumb-segment {
    cursor: default;
    color: #595959;
  }

  .automations-breadcrumb-segment.clickable {
    cursor: pointer;
    color: #1c1726;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }

  .automations-breadcrumb-segment.current {
    color: #1c1726;
    font-weight: 600;
  }

  .automations-breadcrumb-separator {
    color: #8c8c8c;
  }
`;

export const StyledAutomationsCardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(28rem, 1fr));
  gap: 2rem;
  width: 100%;
`;

export const StyledAutomationsEmailList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  .email-automation-intro {
    font-size: 1.4rem;
    line-height: 1.5;
  }
  .email-automation-create-link {
    font-weight: 600;
    text-decoration: underline;
    color: #1c1726;
    cursor: pointer;
  }

  .email-automation-trigger-block {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
  }

  .email-automation-trigger-label {
    font-weight: 600;
    font-size: 1.4rem;
    color: #1c1726;
  }

  .email-automation-select {
    width: 100%;
    max-width: 100%;
  }

  .email-automation-hint {
    font-size: 1.3rem;
  }

  .email-automation-timing-row {
    display: flex;
    align-items: center;
    gap: 0.8rem;
    flex-wrap: wrap;
  }

  .email-automation-timing-tag {
    margin: 0;
    padding: 0.4rem 1.2rem;
    border-radius: 999px;
    border: none;
    background: #ecfdf3;
    color: #166534;
    font-size: 1.3rem;
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
  }

  .email-automation-timing-tag .anticon {
    color: #166534;
  }

  .create-new-automation-row {
    display: flex;
    justify-content: flex-start;
    padding-top: 0.4rem;
  }
`;

export const StyledAutomationsInlineFormFooter = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
  padding: 1.6rem 0 0;
  border-top: 1px solid #f0f0f0;
  flex-wrap: wrap;

  .automations-inline-footer-delete {
    color: #ff4d4f;
    margin-left: auto;
  }
`;

export const StyledAutomationsPanel = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 2rem 2.4rem 2.4rem;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`;

export const StyledAutomationsHeaderRow = styled.div`
  display: block;
`;

export const StyledAutomationsTitle = styled.h2`
  margin: 0 0 0.4rem;
  font-size: 1.8rem;
  font-weight: 600;
  color: #1c1726;
`;

export const StyledAutomationsSubtitle = styled.p`
  margin: 0;
  font-size: 1.4rem;
  color: #8c8c8c;
  line-height: 1.5;
  max-width: 48rem;
`;

export const StyledAutomationsTabBarRow = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1.2rem;
  flex-wrap: wrap;
`;

export const StyledAutomationsTabsWrap = styled.div`
  flex: 1;
  min-width: 0;

  .ant-tabs-nav {
    margin-bottom: 0;
  }
`;

export const StyledAutomationRowCard = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
  padding: 1.2rem 1.6rem;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  background: #fff;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
    padding: 1.6rem;
  }
`;

export const StyledAutomationRowIcon = styled.div`
  width: 4rem;
  height: 4rem;
  min-width: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9fafb;
  border-radius: 8px;
  font-size: 1.8rem;
  color: #4b5563;
`;

export const StyledAutomationRowBody = styled.div`
  flex: 1;
  min-width: 0;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const StyledAutomationRowTitle = styled.div`
  font-weight: 500;
  font-size: 1.4rem;
  color: #1c1726;
  margin-bottom: 0.5rem;
`;

export const StyledAutomationRowTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  align-items: center;
`;

export const StyledAutomationRowActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-shrink: 0;
`;

export const StyledAutomationsListStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const StyledAutomationsTypeFilter = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  flex-wrap: wrap;
`;

export const StyledAutomationsEmpty = styled.div`
  text-align: center;
  padding: 2.4rem 1.6rem;
  color: #595959;
  font-size: 1.4rem;
  line-height: 1.6;

  .empty-links {
    margin-top: 0.8rem;
  }

  .empty-link {
    font-weight: 600;
    text-decoration: underline;
    color: #1c1726;
    cursor: pointer;
  }
`;
